import React from "react"

export const VouchingDetailsContext = React.createContext({
	filter: {},
	setFilterItem: () => {},
	itemFilter: it => true,
})

export default VouchingDetailsContext
